import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBold,
    faUnderline,
    faItalic,
    faListUl,
} from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import ToolbarButton from './ToolbarButton';
import useStyles from './ToolbarStyles';
import Utils from '../../../services/UtilsService';

export const BLOCK_TYPES = [{
    label: <FontAwesomeIcon icon={faListUl}/>,
    tooltip: 'Unordered list',
    style: 'unordered-list-item',
}];

export const INLINE_TYPES = [{
    label: <FontAwesomeIcon icon={faItalic}/>,
    tooltip: 'Italic',
    style: 'ITALIC',
},
{
    label: <FontAwesomeIcon icon={faBold}/>,
    tooltip: 'Bold',
    style: 'BOLD',
},
{
    label: <FontAwesomeIcon icon={faUnderline}/>,
    tooltip: 'Underline',
    style: 'UNDERLINE',
}];

// Modified by AI on 05/26/2026. Edit #1.
const Toolbar = ({
    className = '',
    editorState,
    onToggleBlock = () => {},
    onToggleInline = () => {},
    children = null,
    alignment = 'top',
    areStylingBtnsShown = true,
    templateSelect = null,
}) => {
    const classes = useStyles({ alignment });
    const selection = editorState.getSelection();
    const blockType = editorState.getCurrentContent()
        .getBlockForKey(selection.getStartKey())
        .getType();
    const currentStyle = editorState.getCurrentInlineStyle();
    const toolbarClassName = Utils.getClassName([classes.container, className]);
    const toolbarButtonSetClassName = Utils.getClassName([classes.buttonSet, 'editor-toolbar-buttonset']);

    return (
        <div className={toolbarClassName}>
            {templateSelect}
            <div className={toolbarButtonSetClassName}>
                {areStylingBtnsShown && INLINE_TYPES.map((type) => (
                    <ToolbarButton
                        active={currentStyle.has(type.style)}
                        label={type.label}
                        tooltip={type.tooltip}
                        onToggle={onToggleInline}
                        style={type.style}
                        key={type.style}
                        type={type}
                    />
                ))}
            </div>
            <div className={toolbarButtonSetClassName}>
                {areStylingBtnsShown && BLOCK_TYPES.map((type) => (
                    <ToolbarButton
                        active={type.style === blockType}
                        label={type.label}
                        tooltip={type.tooltip}
                        onToggle={onToggleBlock}
                        style={type.style}
                        key={type.style}
                        type={type}
                    />
                ))}
            </div>
            {children}
        </div>
    );
};

Toolbar.propTypes = {
    className: PropTypes.string,
    onToggleBlock: PropTypes.func,
    onToggleInline: PropTypes.func,
    children: PropTypes.node,
    alignment: PropTypes.oneOf(['top', 'bottom']),
    areStylingBtnsShown: PropTypes.bool,
    templateSelect: PropTypes.node,
};

export default Toolbar;
